function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n    .list_svg__list_svg__st0{fill:#717375}\n  ");

var _ref2 = /*#__PURE__*/React.createElement("title", null, "\n    list\n  ");

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "list_svg__list_svg__st0",
  d: "M17.1,2H5.9C5.8,2,5.6,1.9,5.6,1.7s0.1-0.3,0.3-0.3h11.2c0.2,0,0.3,0.1,0.3,0.3S17.3,2,17.1,2z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "list_svg__list_svg__st0",
  d: "M1.7,3.4C0.8,3.4,0,2.6,0,1.7S0.8,0,1.7,0s1.7,0.8,1.7,1.7S2.6,3.4,1.7,3.4z M1.7,0.7c-0.6,0-1,0.5-1,1 s0.5,1,1,1s1-0.5,1-1S2.3,0.7,1.7,0.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "list_svg__list_svg__st0",
  d: "M1.7,9.1C0.8,9.1,0,8.3,0,7.4c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7C3.4,8.3,2.6,9.1,1.7,9.1z M1.7,6.3 c-0.6,0-1,0.5-1,1s0.5,1,1,1s1-0.5,1-1S2.3,6.3,1.7,6.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "list_svg__list_svg__st0",
  d: "M1.7,14.7C0.8,14.7,0,14,0,13.1c0-0.9,0.8-1.7,1.7-1.7s1.7,0.8,1.7,1.7C3.4,14,2.6,14.7,1.7,14.7z M1.7,12 c-0.6,0-1,0.5-1,1c0,0.6,0.5,1,1,1s1-0.5,1-1C2.7,12.5,2.3,12,1.7,12z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "list_svg__list_svg__st0",
  d: "M17.1,7.7H5.9c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h11.2c0.2,0,0.3,0.1,0.3,0.3S17.3,7.7,17.1,7.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "list_svg__list_svg__st0",
  d: "M17.1,13.4H5.9c-0.2,0-0.3-0.1-0.3-0.3s0.1-0.3,0.3-0.3h11.2c0.2,0,0.3,0.1,0.3,0.3S17.3,13.4,17.1,13.4z"
}))));

function SvgList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.4 14.8",
    style: {
      enableBackground: "new 0 0 17.4 14.8"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2, _ref3);
}

export default SvgList;